export const withLoading =
  (ctx, fn) =>
  async (...args) => {
    if (ctx.state.isLoading) return;
    ctx.commit('setLoading', true);
    try {
      return await fn(...args);
    } finally {
      ctx.commit('setLoading', false);
    }
  };
